export const getDate = (millis: number) => {
  const date = new Date(millis);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};
